export const DATA_ID = {
  SHOW_SIDEBAR: 'show-sidebar',
  PLAY_REAL_GAME: 'play-real-game',
  DEPOSIT_IN_GAME: 'deposit-in-game',
  SLIDER_REDIRECT: 'slider-redirect',
  SLIDER_PLAY: 'slider-play',
  FILTER_CATEGORY: 'filter-category',
  MAIN_CATEGORY: 'main-category',
  MAIN_CATEGORY_DEMO: 'main-category-demo',
  MAIN_CATEGORY_PLAY: 'main-category-play',
  SEARCH_DEMO: 'search-demo',
  SEARCH_PLAY: 'search-play',
  FILTER_DEMO: 'filter-demo',
  FILTER_PLAY: 'filter-play',
  SEARCH_SAME_GAMES_PLAY: 'search-same-games-play',
  SEARCH_SAME_GAMES_DEMO: 'search-same-games-demo',
  PROVIDER: 'provider',
  CATEGORY: 'category',
  PROVIDERS: 'providers',
  CATEGORIES: 'categories',
  FULLSCREEN: 'fullscreen',
  // TODO: use in future when new features will be ready:
  FILTER_FREE_SPIN: 'filter-free-spin',
  FILTER_BONUS: 'filter-bonus',
  FILTER_PROVIDER: 'filter-provider',
  FILTER_REELS: 'filter-reels',
  FILTER_SPIN: 'filter-spin',
  FILTER_THEME: 'filter-theme',
  BONUS_ACTIVATE: 'bonus-activate',
  CANCEL_BONUS: 'cancel-bonus',
  CANCEL_BONUS_CONFIRM: 'cancel-bonus-confirm',
};

export const EVENT_ACTION = {
  SLIDER_REDIRECT: 'slots_more_slider_banner',
  SLIDER_PLAY: 'slots_play_slider_game',
  MAIN_CONTINUE_PLAY: 'slots_main_continue_play',
  CONTINUE_FAVOURITE: 'slots_main_continue_favourite',
  SIMILAR: 'slots_main_similar',
  SIMILAR_PLAY: 'slots_main_similar_play',
  SIMILAR_FAVORITE: 'slots_main_similar_favourite',
  OTHER_GAMES: 'slots_main_other_games',
  OTHER_GAMES_PLAY: 'slots_main_other_games_play',
  OTHER_GAMES_FAVORITE: 'slots_main_other_games_favourite',
  PROVIDER_GAMES: 'slots_main_provider_games',
  PROVIDER_GAMES_PLAY: 'slots_main_provider_games_play',
  PROVIDER_GAMES_FAVORITE: 'slots_main_provider_games_favourite',
  THEME_GAMES: 'slots_main_theme_games',
  THEME_GAMES_PLAY: 'slots_main_theme_games_play',
  JACKPOT_TICKER_PLAY: 'slots_main_jack_pot_tiker_play',
  JACKPOT_TICKER_FAVOURITE: 'slots_main_jack_pot_tiker_favorite',
  JACKPOT_TICKER_ALL_GAMES: 'slots_main_jack_pot_tiker_all_games',
  THEME_GAMES_FAVORITE: 'slots_main_theme_games_favourite',
  CATEGORY_GAMES: 'slots_main_category_games',
  CATEGORY_GAMES_PLAY: 'slots_main_category_games_play',
  CATEGORY_GAMES_FAVORITE: 'slots_main_category_games_favourite',
  CROSS_GAMES: 'slots_main_cross_sale',
  CROSS_DETAIL: 'slots_main_cross_sale_detail',
  ALL_THEMES_REDIRECT: 'slots_main_widget_themes',
  THEME_REDIRECT: 'slots_main_widget_theme',
  ALL_CATEGORIES_REDIRECT: 'slots_main_widget_categorys',
  CATEGORY_REDIRECT: 'slots_main_widget_category',
  ALL_PROVIDERS_REDIRECT: 'slots_main_widget_providers_all',
  PROVIDER_REDIRECT: 'slots_main_widget_provider',
  CASINO_NAVIGATION_CLICK: 'casino_navigation_click',
  NAV_MAIN: 'slots_nav_main',
  NAV_BONUSES: 'slots_nav_bonuses',
  NAV_FAVORITES: 'slots_nav_favorites',
  NAV_BONUS_GAMES_WAGERING: 'slots_nav_to_games_wagering',
  NAV_BONUS_GAMES_COLLECTING: 'slots_nav_to_games_collecting',
  NAV_BONUS_GAMES_FREE_SPINS: 'slots_nav_to_game_free_spins',
  NAV_CATEGORIES: 'slots_nav_categories',
  NAV_PROVIDERS: 'slots_nav_providers',
  NAV_THEMES: 'slots_nav_themes',
  NAV_CATEGORY_ITEM: 'slots_nav_category',
  NAV_PROVIDER_ITEM: 'slots_nav_provider',
  NAV_THEME_ITEM: 'slots_nav_theme',
  NAV_HALL_OF_FAME: 'slots_nav_hall_of_fame',
  QUICK_SEARCH_PREV_GAME: 'slots_quich_search_previos_game',
  QUICK_SEARCH_CATEGORY_GAME: 'slots_quick_search_category_games_play',
  QUICK_SEARCH_FOUND_GAME: 'slots_quick_search_game_play',
  QUICK_SEARCH_ALL_GAMES: 'slots_quick_search_games',
  BIG_WIN_MAIN_PLAY: 'slots_casino_win_card_main',
  BIG_WIN_MEGA_MAIN_PLAY: 'slots_casino_bigwin_card_main',
  BIG_WIN_CATEGORY_PLAY: 'slots_casino_win_card_category',
  BIG_WIN_MEGA_CATEGORY_PLAY: 'slots_casino_bigwin_card_category',
  BIG_WIN_THEME_PLAY: 'slots_casino_win_card_theme',
  BIG_WIN_MEGA_THEME_PLAY: 'slots_casino_bigwin_card_theme',
  BONUS_TILE: 'slots_bonus_tile',
  BONUS_ACTIVATE: 'slots_bonus_activate',
  BONUS_DEPOSIT: 'slots_deposit',
  BONUS_SUPPORT: 'slots_support',
  BONUS_LOGIN: 'slots_bonus_login',
  BONUS_CANCEL: 'slots_cancel_bonus',
  BONUS_TO_GAMES_WAGERING: 'slots_bonus_to_games_wagering',
  BONUS_TO_GAMES_COLLECTING: 'slots_bonus_to_games_collecting',
  BONUS_TO_GAME_COLLECTING_FREE_SPINS:
    'slots_bonus_to_game_collecting_collecting_free_spins',
  BONUS_TAKE_CASHBACK: 'slots_bonus_pick_up',
  BONUS_AVAILABLE: 'slots_bonus_actual',
  MOBILE_NAV_SEARCH: 'slots_search_mobile',
  MOBILE_NAV_SHOW_SIDEBAR: 'slots_show_sidebar_mobile',
  MOBILE_NAV_FAVORITES: 'slots_favorites_mobile',
  THEME_DETAIL_GAMES_PLAY: 'slots_theme_details_games_play',
  THEME_DETAIL_GAMES_FAVORITE: 'slots_theme_details_games_favourite',
  THEME: 'slots_theme',
  CATEGORY: 'slots_category',
  PROVIDER_DETAIL_GAMES_PLAY: 'slots_provider_details_games_play',
  PROVIDER_DETAIL_GAMES_FAVORITE: 'slots_provider_details_games_favourite',
  PROVIDER: 'slots_provider',
  PROVIDER_PLAY: 'slots_provider_games_play',
  PROVIDER_FAVORITE: 'slots_provider_games_favourite',
  PROVIDER_SORT: 'slots_provider_sort',
  PROVIDER_SORT_APPLY: 'slots_provider_sort_apply',
  CATEGORY_DETAIL_PLAY: 'slots_category_details_games_play',
  CATEGORY_DETAIL_FAVORITE: 'slots_category_details_games_favourite',
  GAME_PAGE_PREVIOUS_PLAY: 'slots_previous_games_play',
  GAME_PAGE_PREVIOUS_FAVORITE: 'slots_previuos_games_favourite',
  GAME_PAGE_OTHER_GAMES: 'slots_other_games',
  GAME_PAGE_OTHER_GAMES_PLAY: 'slots_other_games_play',
  GAME_PAGE_OTHER_GAMES_FAVORITE: 'slots_other_games_favourite',
  GAME_PAGE_SIMILAR_GAMES: 'slots_similar',
  GAME_PAGE_SIMILAR_GAMES_PLAY: 'slots_similar_play',
  GAME_PAGE_SIMILAR_GAMES_FAVORITE: 'slots_similar_favourite',
  GAME_PAGE_DEMO: 'slots_play_demo_game',
  GAME_PAGE_REAL: 'slots_play_real_game',
  GAME_PAGE_FULLSCREEN: 'slots_fullscreen',
  GAME_PAGE_FAVORITE: 'slots_add_favourite',
  GAME_PREVIEW_PAGE_DEMO: 'slots_preview_play_demo_game',
  GAME_PREVIEW_PAGE_REAL: 'slots_preview_play_real_game',
  GAME_PREVIEW_PAGE_CLOSE: 'slots_preview_game_close',
  GAME_PAGE_CLOSE: 'slots_game_close',
  WAGERING_BONUS_PAGE_SELECT_WAGERING: 'slots_casino_wagering',
  WAGERING_BONUS_PAGE_PLAY: 'slots_casino_wagering_game_play',
  WAGERING_BONUS_PAGE_FAVOURITE: 'slots_casino_wagering_game_favourite',
  FAVORITE_PAGE_PLAY: 'slots_favourite_game_play',
  FAVORITE_PAGE_FAVORITE: 'slots_favorite_games_favourite',
  SEARCH_GAME_PLAY: 'slots_search_game_play',
  SEARCH_GAME_FAVORITE: 'slots_search_game_favorite',
  SEARCH_PREVIOUS_GAMES_PLAY: 'slots_search_previous_games_play',
  SEARCH_PREVIOUS_GAMES_FAVOURITE: 'slots_search_previous_games_favourite',
  SEARCH_CATEGORY_GAMES: 'slots_search_category_games',
  SEARCH_CATEGORY_GAMES_PLAY: 'slots_search_category_games_play',
  SEARCH_CATEGORY_GAMES_FAVOURITE: 'slots_search_category_games_favourite',
  RANDOM_GAME: 'slots_random_game',
  RANDOM_GAME_ERROR: 'slots_random_game_error',
  RANDOM_GAME_SUCCESS: 'slots_random_game_success',
  MAIN_BALANCE: 'slots_main_balance',
  PREVIEW_SUGGESTION_ADD_TO_FAVORITE:
    'slots_preview_suggestion_add_to_favorite',
  PREVIEW_SUGGESTION_PLAY: 'slots_preview_suggestion_play',
  PREVIEW_SUGGESTION_GAMES: 'slots_preview_suggestion_games',
  //
  HALL_OF_FAME_CURRENT: 'hall_of_fame_current',
  HALL_OF_FAME_PREVIOUS: 'hall_of_fame_previous',
  HALL_OF_FAME_CURRENT_PLAY: 'hall_of_fame_current_play_game',
  HALL_OF_FAME_PREVIOUS_PLAY: 'hall_of_fame_previous_play_game',
  HALL_OF_FAME_EMPTY: 'hall_of_fame_empty',
  HALL_OF_FAME_WINNER_WIDGET: 'hall_of_fame_winner',
  HALL_OF_FAME_WINNER_CHECK: 'hall_of_fame_winner_check',
  HALL_OF_FAME_MONTH_SELECT: 'hall_of_fame_months_select', // will be used later

  CROSS_SALE_WIDGET_ALL_GAMES: 'slots_cross_sale_widget_all_games',
  CROSS_SALE_WIDGET_PLAY: 'slots_cross_sale_widget_play_game',
};

export const DATA_LAYER_EVENT = 'slots_casino';
export const DATA_LAYER_EVENT_CATEGORY = 'slots_casino';
